import { render, staticRenderFns } from "./AddDelegateModal.vue?vue&type=template&id=57a5b0c6&scoped=true&"
import script from "./AddDelegateModal.vue?vue&type=script&lang=js&"
export * from "./AddDelegateModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDelegateModal.vue?vue&type=style&index=0&id=57a5b0c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5b0c6",
  null
  
)

export default component.exports